module.exports = __webpack_public_path__ + "static/media/WHY_WBN_B2B.b25b7202.png";